import { render, staticRenderFns } from "./loading_overlay.vue?vue&type=template&id=1080b368&"
import script from "./loading_overlay.vue?vue&type=script&lang=js&"
export * from "./loading_overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports